import Grid from "@mui/material/Grid";
import ConnectionTile from "./ConnectionTile";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SpeedOutlined from "@mui/icons-material/SpeedOutlined";
import { usePermissions } from "../../hooks/usePermissions";
import {
  POWERBI_CCMR_INTERNAL_VIEW,
  POWERBI_CCMR_SLA_REPORTING_VIEW, POWERBI_CLIENT_DASHBOARD_VIEW,
  POWERBI_DQ_INSIGHTS_VIEW,
  POWERBI_OPERATIONAL_DASHBOARD_VIEW,
} from "../permission/permission-consts";
import { useNavigate } from "react-router-dom";
import InsightsIcon from '@mui/icons-material/Insights';

export const POWERBI_REPORT_LIST = [
  {
    title: "Client Dashboard",
    description: "A comprehensive client dashboard that provides a consolidated view of portfolio performance, net client value, litigation progression, collections, and key insights for effective monitoring and decision-making.",
    Icon: InsightsIcon,
    permission: POWERBI_CLIENT_DASHBOARD_VIEW,
    url: "/powerbi/client-dashboard",
    // sx: { pt: '12px !important' }
  },
  {
    title: "LegalStream Operational Dashboard",
    description: "A consolidated view of account placements, firm assignments, and key legal activities across the portfolio, helping users track performance, monitor trends, and drill down into account-level details.",
    Icon: SpeedOutlined,
    permission: POWERBI_OPERATIONAL_DASHBOARD_VIEW,
    url: "/powerbi/operational-dashboard",
    // sx: { pt: '12px !important' }
  },
  {
    title: "CCMR Internal Reporting",
    description: "Summarizes key account metrics, SLA adherence, and litigation workflows, including contested cases, with a drill-through accounts page for full account details.",
    Icon: AssessmentIcon,
    permission: POWERBI_CCMR_INTERNAL_VIEW,
    url: "/powerbi/ccmr",
    // sx: { pt: '12px !important' }
  },
  {
    title: "DQ Insights - Maintenance",
    description: "Summarizes inconsistency counts across maintenance files from multiple firms, with a detailed accounts page where missing fields are highlighted for quick identification.",
    Icon: FactCheckOutlinedIcon,
    permission: POWERBI_DQ_INSIGHTS_VIEW,
    url: "/powerbi/dq",
    // sx: { pt: '12px !important' }
  },
  {
    title: "CCMR SLA Reporting",
    description: "Comprehensive view of SLA performance for CCMR accounts, including SLA eligibility, outside SLA counts with percentages, key exceptions, and overall compliance trends",
    Icon: SummarizeIcon,
    permission: POWERBI_CCMR_SLA_REPORTING_VIEW,
    url: "/powerbi/ccmr-sla",
    // sx: { pt: '12px !important' }
  }
];

const Home = () => {
  const navigate = useNavigate();
  const { permissions } = usePermissions();

  return (
      <Grid container spacing={3} sx={{ p: 4 }}>
        {POWERBI_REPORT_LIST
            .filter((card) => permissions?.includes(card.permission))
            .map((card, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <ConnectionTile
                      title={card.title}
                      description={card.description}
                      IconComponent={card.Icon}
                      onClick={() => navigate(card.url)}
                  />
                </Grid>
            ))}
      </Grid>
  );
};

export default Home;